export function useCatalogAPI() {
  const { errors, request } = useRequest();

  async function getWholeSalers() {
    const url = versionedUrl('Catalog/GetWholeSalers');

    return await request<WholesalersResponse[]>(url);
  }

  async function SearchAllItems(requestBody: SearchAllItemsRequest, includeWholesalerImages: boolean, includeOwnItemImages: boolean) {
    const url = `${versionedUrl('Catalog/SearchAllItems')}?includeWholesalerImages=${includeWholesalerImages}&includeOwnItemImages=${includeOwnItemImages}`;
    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody
    };

    return await request<MaterialItemApp[]>(url, requestOptions);
  }

  async function CreatePersonalMaterialFavoriteList(requestBody: PersonalFavoriteListName) {
    const url = versionedUrl('Catalog/CreatePersonalMaterialFavoriteList');
    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody
    };

    return await request<MaterialFavoriteList>(url, requestOptions);
  }

  async function addMaterialsToFavoriteList(requestBody: MaterialFavoriteListIdRecordIds) {
    const url = versionedUrl('Catalog/AddMaterialsToFavoriteList');
    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody
    };

    return await request<boolean>(url, requestOptions);
  }

  async function removeMaterialsFromFavoriteList(requestBody: MaterialFavoriteListIdRecordIds) {
    const url = versionedUrl('Catalog/RemoveMaterialsFromFavoriteList');
    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody
    };

    return await request<boolean>(url, requestOptions);
  }

  async function fetchWholesalerItemByElasticSearch(requestBody: AppIonicSearchItemRequestDTO, includeImages: boolean) {
    const url = `${versionedUrl('Catalog/SearchWholesalerItemsElastic')}?includeImages=${includeImages}`;
    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody
    };

    return await request<SearchItemResponse>(url, requestOptions);
  }

  async function GetMaterialFavoriteListsInfoConnectedToFitter() {
    const url = versionedUrl('Catalog/GetMaterialFavoriteListsInfoConnectedToFitter');
    const requestOptions: RequestOptions = {
      method: 'get'
    };

    return await request<FavoriteListInfoDTO[]>(url, requestOptions);
  }

  async function GetMaterialItemsForFavoriteListApp(requestBody: MaterialFavoriteListAppRequestDTO, isPersonalList: boolean, includeImages: boolean) {
    //change these after 2.0.26
    const url = `${versionedUrl('Catalog/GetMaterialItemsForFavoriteListAppV2')}?isPersonalList=${isPersonalList}&includeImages=${includeImages}`;
    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody
    };

    return await request<FavoriteListItemApp>(url, requestOptions);
  }

  return {
    errors,
    fetchWholesalerItemByElasticSearch,
    CreatePersonalMaterialFavoriteList,
    getWholeSalers,
    addMaterialsToFavoriteList,
    removeMaterialsFromFavoriteList,
    GetMaterialFavoriteListsInfoConnectedToFitter,
    GetMaterialItemsForFavoriteListApp,
    SearchAllItems
  };
}
